module.exports = __webpack_public_path__ + "static/img/6394_phase_function_Paper_Points.877f381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6394_phase_function_Paper_Points.png
// module id = NNa9
// module chunks = 0